// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3KLKV","label":"styles_label__1YrIh"};